<form [formGroup]="updateStatusForm">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Update Status</h4>
        <button type="button" class="btn-close" aria-label="Close"
            (click)="resetFrom();activeModal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="card1">
                    <!-- <div class="card-header bg-transparent border-bottom text-uppercase">Update Status</div> -->
                    <div class="card-body1">
                        <!-- <div class="row">
                            <div class="col-12">
                                <div class="alert alert-secondary alert-dismissible fade show mb-0 justify-content-center"
                                    role="alert">
                                    Current Status: <span class="badge bg-dark statusbadge" *ngIf="currentStatus">
                                        {{currentStatus}}</span>
                                </div>
                            </div>
                        </div> -->
                        <!-- <div class="row mt-2">
                            <div class="col-md-12">
                                <label class="form-label custom-info-label">
                                    <i class="mdi mdi-alert-circle-outline me-1"></i>
                                    Note: Updating master AWB also updates status for all of their childs as well.
                                </label>
                            </div>
                        </div> -->
                        <div class="row mt-2">
                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="ddlAwb" class="form-label">Available AWB<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="ddlAwb" [items]="availableAwbList" bindLabel="awbnumber"
                                        placeholder="Select" [bindValue]="'awbnumber'"
                                        formControlName="ddlAwb" aria-readonly="true" [groupBy]="'parentawbnumber'"
                                        [multiple]="true" [selectableGroup]="true" [closeOnSelect]="false"
                                        [selectableGroupAsModel]="false" [hideSelected]="false"
                                        [clearSearchOnAdd]="true" [appendTo]="'ngb-modal-window'" [openOnEnter]="false"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{ 'is-invalid':(isFormSubmitted || updateStatusForm.get('ddlAwb').touched) && updateStatusForm.get('ddlAwb').errors }">

                                        <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">

                                            <div class="ng-value" *ngFor="let item of items | slice:0:5;">
                                                <span class="ng-value-label">{{item.awbnumber}}</span>
                                                <span class="ng-value-icon right" (click)="clear(item)"
                                                    aria-hidden="true">×</span>
                                            </div>

                                            <div class="ng-value" *ngIf="items.length > 5">
                                                <span class="ng-value-label">{{items.length - 5}} more...</span>
                                            </div>

                                        </ng-template>

                                        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$"
                                            let-index="index">
                                            <ng-container>
                                                <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                                    *ngIf="item.parentawbnumber !== ''"
                                                    [ngModelOptions]="{ standalone : true }" /> {{item.parentawbnumber}}
                                            </ng-container>

                                        </ng-template>
                                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"
                                                [ngModelOptions]="{ standalone : true }" [disabled]="item.disabled"
                                                /> {{item.awbnumber}}
                                        </ng-template>

                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || updateStatusForm.get('ddlAwb').touched) && updateStatusForm.get('ddlAwb').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="updateStatusForm.get('ddlAwb').errors.required">You must select atleast one
                                            AWB to create</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-md-4">
                                <div class="mb-2">
                                    <label for="excepteddelvdate" class="form-label">Action Date<span
                                            class="mandatory">*</span></label>
                                    <input type="datetime-local" id="excepteddelvdate"
                                        class="form-control form-control-sm" formControlName="txtActionDate"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || updateStatusForm.get('txtActionDate')?.touched) && updateStatusForm.get('txtActionDate').errors}">
                                    <div *ngIf="(isFormSubmitted || updateStatusForm.get('txtActionDate')?.touched) && updateStatusForm.get('txtActionDate').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="updateStatusForm.get('txtActionDate').errors.required">Action Date is
                                            required.</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                        <div class="row">

                            <div class="col-md-12">
                                <div class="mb-2">
                                    <label for="remark" class="form-label">Status <span class="mandatory">*</span></label>
                                    <div class="input-group">
                                        <input formControlName="txtCustomStatus" type="text"
                                            class="form-control col form-control-sm" placeholder="Type to search"
                                            [ngClass]="{'is-invalid':(isFormSubmitted ||updateStatusForm.get('txtCustomStatus').touched) &&updateStatusForm.get('txtCustomStatus').errors}" />
                                    </div>
                                    <ng-template #rt let-r="result" let-t="term">
                                        <ngb-highlight [result]="r.remark" [term]="t"></ngb-highlight>
                                    </ng-template>

                                    <div *ngIf="(isFormSubmitted || updateStatusForm.get('txtCustomStatus').touched) &&updateStatusForm.get('txtCustomStatus').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="updateStatusForm.get('txtCustomStatus').errors.required">
                                            Remark is Required
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="row" *ngIf="isShipmentHold" formGroupName="shipmentHoldDetails">
                                <div class="col-md-8">
                                    <div class="mb-2">
                                        <label for="" class="form-label">Email</label>
                                        <input type="text" placeholder="Enter a Email"
                                            class="form-control form-control-sm" formControlName="txtEmail"
                                            [ngClass]="{'is-invalid':(isFormSubmitted || updateStatusForm.get('shipmentHoldDetails.txtEmail').touched) && updateStatusForm.get('shipmentHoldDetails.txtEmail').errors}">
                                        <div *ngIf=" (isFormSubmitted || updateStatusForm.get('shipmentHoldDetails.txtEmail').touched) && updateStatusForm.get('shipmentHoldDetails.txtEmail').errors"
                                            class="invalid-feedback">
                                            <span
                                                *ngIf="updateStatusForm.get('shipmentHoldDetails.txtEmail').errors.pattern">Invalid
                                                Email.</span>
                                        </div>
                                    </div>
                                </div>
                            </div> -->

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="onSaveClick()" (keydown.enter)="useEnterKey ? $event.preventDefault() : onSaveClick()">Save</button>
    </div>
</form>